import '../utils/test.css';

import React, { useEffect, useState } from "react";


const RandomShapes = () => {
  const [shapes, setShapes] = useState([]);

  const generateShape = () => {
    const shapeTypes = ["square", "circle"];
    const type = shapeTypes[Math.floor(Math.random() * shapeTypes.length)];
    const xPos = Math.random() * 100; // Position X aléatoire
    const yPos = Math.random() * 100; // Position Y aléatoire
    const xSpeed = Math.random() * 2 - 1; // Vitesse X (aléatoire entre -1 et 1)
    const ySpeed = Math.random() * 2 - 1; // Vitesse Y (aléatoire entre -1 et 1)

    return {
      id: Date.now() + Math.random(),
      type,
      xPos,
      yPos,
      xSpeed,
      ySpeed,
    };
  };

  useEffect(() => {
    // Initialiser les formes
    const initialShapes = Array.from({ length: 15 }).map(generateShape);
    setShapes(initialShapes);

    const interval = setInterval(() => {
      setShapes((prevShapes) =>
        prevShapes.map((shape) => {
          let newX = shape.xPos + shape.xSpeed;
          let newY = shape.yPos + shape.ySpeed;

          // Si la forme sort des bords, réinitialise-la à une position aléatoire
          if (newX < 0 || newX > 100 || newY < 0 || newY > 100) {
            return generateShape();
          }

          return { ...shape, xPos: newX, yPos: newY };
        })
      );
    }, 50);

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <div className='base-cube'>
        <div class="cube">
          <div class="face front "></div>
          <div class="face back ">I</div>
          <div class="face left ">E</div>
          <div class="face right ">R</div>
          <div class="face top ">R</div>
          <div class="face bottom ">E</div>
        </div>
      </div>
      



      <div className='test'>
        <div className="animation-area">
          {shapes.map((shape) => (
            <div
              key={shape.id}
              className={`shape ${shape.type}`}
              style={{ top: `${shape.yPos}vh`, left: `${shape.xPos}vw` }}
            />
          ))}
        </div>
      </div>
    </div>
    
  )
}



export default function Test() {
  return (
    <div class="*">
      <h1>
        Background Animation
      </h1>
      <RandomShapes />
    </div>
  )
}